import { Flex, Image, Link, Text } from '@magalu/stereo-ui/atoms';
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { SectionSeller } from './styles';
var AdsBrandSellerInfo = function AdsBrandSellerInfo(_ref) {
  var logo = _ref.logo,
    headline = _ref.headline,
    subtitle = _ref.subtitle,
    buttonTitle = _ref.buttonTitle,
    redirectUrl = _ref.redirectUrl,
    handleBrandClick = _ref.handleBrandClick,
    template = _ref.template;
  return React.createElement(SectionSeller, {
    "data-testid": "section-seller",
    style: {
      margin: template === 'creative' ? '0 0 0 14px' : '0 0 0 22px',
      maxHeight: '254px',
      width: '174px'
    }
  }, React.createElement(Image, {
    src: logo,
    style: {
      maxHeight: 100,
      maxWidth: 174
    }
  }), React.createElement(Flex, {
    width: 174,
    flexDirection: "column",
    gap: 1
  }, headline && React.createElement(Text, {
    "data-testid": "headline",
    color: "text.base",
    fontWeight: "600",
    fontSize: 2
  }, headline), subtitle && React.createElement(Text, {
    "data-testid": "subtitle",
    color: "text.base",
    fontWeight: "200",
    lineHeight: 1.25,
    fontSize: 2
  }, subtitle)), React.createElement(Flex, {
    gap: 1
  }, buttonTitle && redirectUrl && React.createElement(React.Fragment, null, React.createElement(Link, {
    "data-testid": "link",
    href: redirectUrl,
    color: "text.primary",
    fontWeight: "600",
    fontSize: 2,
    onMouseDown: handleBrandClick,
    onClick: function onClick(e) {
      return e.preventDefault();
    }
  }, buttonTitle), React.createElement(Icon, {
    color: "text.primary",
    name: "ChevronRight",
    "data-testid": "icon"
  }))));
};
AdsBrandSellerInfo.defaultProps = {
  buttonTitle: null,
  handleBrandClick: function handleBrandClick() {},
  headline: null,
  logo: null,
  redirectUrl: '#',
  styles: {},
  subtitle: null,
  template: ''
};
process.env.NODE_ENV !== "production" ? AdsBrandSellerInfo.propTypes = {
  buttonTitle: PropTypes.string,
  handleBrandClick: PropTypes.func,
  headline: PropTypes.string,
  logo: PropTypes.string,
  redirectUrl: PropTypes.string,
  styles: PropTypes.shape({}),
  subtitle: PropTypes.string,
  template: PropTypes.string
} : void 0;
AdsBrandSellerInfo.ssr = true;
export default AdsBrandSellerInfo;